
import Vue from 'vue'
export default Vue.extend({
  props: {
    icon: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: ''
    }
  },
  render() {
    return (
      <span
        class={['iconfont', this.icon]}
        style={this.color && `color: ${this.color}`}
      />
    )
  }
})
